// *******************************************************************************
// news-list filter
// *******************************************************************************

const newsListEle = document.querySelector('.news-list');

if (newsListEle) {
  const cmsSelectedCategories = newsListEle.getAttribute('data-cms-selected-category');
  const newsListInner = newsListEle.querySelector('.news-list__row');
  const newsListPagination = newsListEle.querySelector('.news-list__footer');
  const newsListNoPosts = newsListEle.querySelector('.news-list__no-posts');
  const filterAll = newsListEle.querySelector('[data-filter-all]');
  let allBtnValue = '';
  if (filterAll) {
    allBtnValue = filterAll.getAttribute('data-filter-all');
  }

  const sendNewsListAjax = async (categoriesId, allBtnValue) => {
    try {
      const response = await axios.post(
        localData.siteURL,
        {
          action: 'getFilteredNewsListPosts',
          id: localData.id,
          categoriesId,
          allBtnValue,
          moduleName: 'newsList',
        },
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      window.history.replaceState(null, null, response.data.data.pageLink);
      newsListInner.innerHTML = response.data.data.posts;
      newsListPagination.innerHTML = response.data.data.pagination || '';
      newsListNoPosts.classList.add('hide');

      if (response.data.data.noPosts) {
        newsListNoPosts.classList.remove('hide');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const newsAjax = (allElem) => {
    const allItems = newsListEle.querySelectorAll(allElem);
    const categoriesId = getActiveCaregoryIds(allItems);
    sendNewsListAjax(categoriesId || cmsSelectedCategories, categoriesId === '' ? allBtnValue : '');
  };

  attachEvent('.news-list .category-list__item', 'click', () => {
    newsAjax('.news-list .category-list__item.is-active');
  });

  // On window load show msg if no any posts
  window.addEventListener('load', () => {
    if (newsListInner.innerHTML.trim() === '') {
      newsListNoPosts.classList.remove('hide');
    }
  });
}
